<template>
  <div class="check-point-card">
    <a-row class="check-point-card__meta">
      <a-col class="check-point-card__name">
        {{ checkPoint.description }}
      </a-col>
      <a-col class="check-point-card__status">
        <task-due-to-date-label
          :date-completed="checkPoint.dateCompleted"
          :due-to-date="checkPoint.dueToDate"
          :date="checkPoint.date"
        />
      </a-col>
    </a-row>

    <a-row class="check-point-card__info">
      <div>
        Номер проекта: <span>{{ checkPoint.projectId }}</span>
      </div>
      <div>
        Проект: <span>{{ checkPoint.projectName }}</span>
      </div>
      <div>Руководитель проекта</div>
      <project-person
        :avatar="getAvatarUrl(checkPoint.leaderAvatarUid)"
        :name="checkPoint.leaderName"
        :email="checkPoint.leaderEmail"
      />
    </a-row>
  </div>
</template>

<script setup>
  import ProjectPerson from './ProjectPerson.vue';
  import TaskDueToDateLabel from '@/components/task-date-label/TaskDueToDateLabel.vue';

  defineProps({
    checkPoint: Object,
  });

  const getAvatarUrl = (avatar) =>
    avatar ? `/api/v1/attachment/${avatar}` : null;
</script>

<style lang="scss">
  @use '@/assets/styles/_colors.scss' as *;

  .check-point-card {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    background: $color-bg-secondary-grey;
    padding: 16px 16px 20px 20px;
    height: 100%;

    &:hover {
      box-shadow: 0 6px 15px 0 rgba(1, 1, 1, 0.15);
    }

    .check-point-card__meta {
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      justify-content: space-between;

      .check-point-card__name {
        color: $color-text-primary;
        font-family: 'Nunito Sans', sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
      }

      .check-point-card__status {
        margin-left: 16px;
      }
    }

    .check-point-card__info {
      color: $color-bg-status-new;
      display: flex;
      flex-direction: column;
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      margin-top: 20px;
      row-gap: 18px;

      span {
        font-weight: 400;
      }
    }
  }
</style>
